import type { ComponentProps } from 'react'

import { DRAW_CANVAS_BOX } from '@/components/practice/draw-canvas/draw-canvas-box'
import { cn } from '@/lib/utils'

/**
 * Renders a loading placeholder with the exact em-box of the draw canvas.
 *
 * @remarks
 * Kept out of the `'use client'` canvas module so route `loading.tsx`
 * files can render it as a server component.
 */
export function DrawCanvasSkeleton({
    className,
    ...props
}: ComponentProps<'div'>) {
    return (
        <div
            className={cn(
                DRAW_CANVAS_BOX,
                'animate-pulse rounded-sm bg-surface-sunken',
                className
            )}
            {...props}
        />
    )
}
